import axios from 'axios';
import config from './config';

const API_BASE_URL = config.API_BASE_URL;

export const fetchAllFilters = async () => {
  const res = await axios.get(`${API_BASE_URL}/filters`);
  return res.data;
};

export const fetchBranchFilters = async (branchId) => {
  const res = await axios.get(`${API_BASE_URL}/Branches/${branchId}/filters`);
  return res.data;
};

export const assignBranchFilters = async (branchId, filterIds) => {
  const res = await axios.post(`${API_BASE_URL}/Branches/${branchId}/filters`, { filterIds });
  return res.data;
};
